module.exports = __webpack_public_path__ + "img/stripe.20de8e5b.png";